import { targetingTypes } from '../../../LineItemDv360Create/fields'
import {
  APPS,
  CHANNELS,
  CHANNELS_EXCLUDED,
  TARGET_SPECIFIC_URLS_OR_APPS,
  URLS,
  YES_USING_PRE_SAVED_SITE_LISTS
} from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { OPTION_YES } from '../../../../../../constants/forms'

export const getInitialValues = ({ targeting, attachedChannels, excludedAttachedChannels }) => {
  const formattedChannelsOptions = attachedChannels.map(channel => ({
    ...channel,
    value: channel.id,
    label: channel.name
  }))

  const formattedExcludedChannelsOptions = excludedAttachedChannels.map(channel => ({
    ...channel,
    value: channel.id,
    label: channel.name
  }))

  const urlsData = targeting.reduce(
    (acc, option) => {
      if (option.type === targetingTypes.TARGETING_TYPE_URL) {
        option.negative ? acc.excluded.push(option.url) : acc.included.push(option.url)
      }
      return acc
    },
    { included: [], excluded: [] }
  )
  const urlsMaxLength = Math.max(urlsData.included.length, urlsData.excluded.length)
  const urlsTable = Array.from(
    {
      length:
        urlsMaxLength >= 10
          ? urlsMaxLength
          : // if maxLength is less than 10, fill the array with 10 elements
            10
    },
    (_, index) => {
      return [{ value: urlsData.included[index] }, { value: urlsData.excluded[index] }]
    }
  )

  const appsData = targeting.reduce(
    (acc, option) => {
      if (option.type === targetingTypes.TARGETING_TYPE_APP) {
        option.negative ? acc.excluded.push(option.app_id) : acc.included.push(option.app_id)
      }
      return acc
    },
    { included: [], excluded: [] }
  )
  const appsMaxLength = Math.max(appsData.included.length, appsData.excluded.length)
  const appsTable = Array.from(
    {
      length:
        appsMaxLength >= 10
          ? appsMaxLength
          : // if maxLength is less than 10, fill the array with 10 elements
            10
    },
    (_, index) => {
      return [{ value: appsData.included[index] }, { value: appsData.excluded[index] }]
    }
  )

  return {
    [TARGET_SPECIFIC_URLS_OR_APPS]:
      urlsData.included.length || urlsData.excluded.length || appsData.included.length || appsData.excluded.length
        ? OPTION_YES
        : YES_USING_PRE_SAVED_SITE_LISTS,
    [CHANNELS]: formattedChannelsOptions,
    [CHANNELS_EXCLUDED]: formattedExcludedChannelsOptions,
    [URLS]: urlsTable,
    [APPS]: appsTable
  }
}
